









import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { JobListingTerm } from '@/utils/types'

@Component
export default class JobListingTable extends Vue {
  @Prop(String) term!: keyof JobListingTerm
  @Prop(Boolean) value!: boolean

  get translateTermToHebrew () {
    switch (this.term) {
      case 'isOnSaturday':
        return 'העבודה במהלך יום שבת'
      case 'isPublicTransportationAccessible':
        return 'נגיש לתחבורה ציבורית'
      case 'isInShifts':
        return 'העבודה במשמרות'
      case 'isTravelsRefunded':
        return 'החזרי נסיעות'
      case 'isBreaks':
        return 'הפסקות'
      case 'isSalaryRaisable':
        return 'אופציה להעלאה בשכר'
      case 'isPaidTraining':
        return 'התלמדות בתשלום'
      case 'isTips':
        return 'טיפים'
      case 'isShuttles':
        return 'הסעות'
      case 'isAccessibleForTheDisabled':
        return 'נגיש לנכים'
      case 'isOvertime':
        return 'שעות נוספות'
      default:
        return this.term
    }
  }
}
